import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './locales/en';
import zh from './locales/zh';

Vue.use(VueI18n);

const locale = localStorage.getItem('lang') || 'zh';

const i18n = new VueI18n({
  locale, // 默认语言
  fallbackLocale: 'en', // 备用语言
  messages: { en, zh }
});

export default i18n;